declare global {
  interface Window {
    __APP_CONFIG__?: {
      VITE_API_URL?: string;
      VITE_WS_URL?: string;
    };
  }
}

function runtime(key: 'VITE_API_URL' | 'VITE_WS_URL'): string | undefined {
  const fromWindow = typeof window !== 'undefined' ? window.__APP_CONFIG__?.[key] : undefined;
  if (fromWindow) return fromWindow;
  const fromEnv = import.meta.env[key] as string | undefined;
  return fromEnv || undefined;
}

export const API_URL = runtime('VITE_API_URL') ?? 'http://localhost:3000/api/v1';
export const WS_URL = runtime('VITE_WS_URL') ?? 'ws://localhost:3000';
